// Copyright (c) 2016 Deere & Company

import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import actions from '../../actions-list';
import {getDefaultState} from '../state/date-range';

const updateDeliveryDate = (state, action) =>
    DateRange.update(state, {
        from: {
            $set: action.deliveryDateRange.from
        },
        to: {
            $set: action.deliveryDateRange.to
        }
    });

const reset = () => getDefaultState();

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_REGISTRATIONS_REVIEW_CRITERIA]: reset,
        [actions.UPDATE_REGISTRATIONS_REVIEW_DELIVERY_DATE]: updateDeliveryDate
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/registrations-review/reducers/delivery-date.js